export default "__VITE_ASSET__CpWs7zYm__"